














































































































































import { Vue, Component } from 'vue-property-decorator'
import { exportJson2Excel } from '@/utils/excel'
import { formatJson, deepCopy } from '@/utils/tool'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

const tableList = [
  {
    id: 1,
    appName: 'TutuApp',
    appSize: '23MB',
    appVersion: 'v2.4.0',
    code: '2019073101',
    newFunction: '优化用户体验',
    path: '/app/android/tutuapp_v3.4.1.apk',
    state: 0,
    updateDate: '2019/08/25'
  }
]

@Component({
  name: 'ProductionAndroidList'
})
export default class extends mixins(DateOption) {
  // data
  params = {
    updateDateStart: '',
    updateDateEnd: '',
    page: 1,
    pageCount: 20
  }
  tableLoading = false
  tableData: any[] = []
  totalCount: number = 0
  dateArray: string[] = ['', '']
  tableHeight: number = 800
  // lifecycle
  created() {
    this.getTableData()
  }
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }
  // methods
  getTableData() {
    this.tableLoading = true
    for (let i = 0; i < 10; i++) {
      this.tableData.push(tableList[0])
    }
    this.tableLoading = false
  }
  setTableHeight() {
    this.tableHeight = document.body.clientHeight - 310
  }
  handleDateChange(date: string[] | any) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    this.params.page = 1
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    this.params.page = 1
    this.dateArray = ['', '']
  }
  handleAdd() {
    this['$router'].push({
      name: 'ProductionAndroidAdd'
    })
  }
  handleEdit(item: any) {
    this['$router'].push({
      name: 'ProductionAndroidEdit',
      query: {
        id: item.id
      }
    })
  }
  handleView(item: any) {
    this['$router'].push({
      name: 'ProductionAndroidView',
      query: {
        id: item.id
      }
    })
  }
  handleExcel() {
    // let excelParams = deepCopy(this.params)
    // let res: any = await getIosList(
    //   Object.assign(excelParams, {
    //     page: 1,
    //     pageCount: 3000
    //   })
    // )
    // if (res.status.code === 0) {
    //   this['$message'].success('导出成功')
    // } else {
    //   this['$message'].error('导出失败')
    //   return
    // }
    // const filterVal: string[] = [
    //   'id',
    //   'name',
    //   'developer',
    //   'category',
    //   'source',
    //   'version',
    //   'price',
    //   'socre',
    //   'status',
    //   'editor',
    //   'updateDate'
    // ]
    // const theader: string[] = [
    //   'ID',
    //   '名称',
    //   '开发者',
    //   '类别',
    //   '来源',
    //   '版本',
    //   '价格',
    //   '评分',
    //   '应用状态',
    //   '编辑人',
    //   '最后修改时间'
    // ]
    // const list = res.data.dataList
    // const data = formatJson(filterVal, list)
    // exportJson2Excel(theader, data)
  }
}
